namespace TabAurous.Retail {
    export namespace POSQuotationItemsForInvoiceService {
        export const baseUrl = 'Retail/POSQuotationItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<POSQuotationItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Retail/POSQuotationItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>POSQuotationItemsForInvoiceService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
